import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { template } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'
import { getSandreList } from '../../../../utils/StoreUtils'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import Checkbox from '../../../../components/forms/Checkbox'
import NumberField from '../../../../components/forms/NumberField'
import DtoCaptureStation from '../dto/DtoCaptureStation'
import Select from '../../../../components/forms/Select'
import {
    getVisitCheckBoxChange,
    getVisitDatePickerChange,
    getVisitSandreSelectChange,
} from '../../../../utils/VisitUtils'
import { getDate } from '../../../../utils/DateUtil'
import { getGeneralLevelling } from '../../../../utils/SettingUtils'
import { onChangeDate } from '../../../../utils/FormUtils'
import Input from '../../../../components/forms/Input'
import { Grid } from '@mui/material'

const CaptureCivilEngPanel = ({
    onChange = () => { },
    onChangeVisit = () => { },
    capture = {},
    readMode = false,
}) => {
    const {
        sandreCodes,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)

    const onChangeCaptureCivilEng = (value) => {
        onChange({
            link_civilEngs: [
                {
                    idStation: capture.idStation,
                    ...capture.link_civilEngs[0],
                    ...value,
                },
            ],
        })
    }

    const civilEng = capture.link_civilEngs[0] || {}

    return (
        <>
            <Grid size={6}>
                <NumberField
                    value={civilEng.depthForation}
                    title={i18n.depthForation}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ depthForation: v })
                        onChangeVisit({ previousValue: civilEng.depthForation, newValue: v, field: i18n.depthForation })
                    }}
                    floatValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <NumberField
                    value={civilEng.interneCasingDiameter}
                    title={i18n.interneCasingDiameter}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ interneCasingDiameter: v })
                        onChangeVisit({ previousValue: civilEng.interneCasingDiameter, newValue: v, field: i18n.interneCasingDiameter })
                    }}
                    floatValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <NumberField
                    value={civilEng.thicknessCasing}
                    title={i18n.thicknessCasing}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ thicknessCasing: v })
                        onChangeVisit({ previousValue: civilEng.thicknessCasing, newValue: v, field: i18n.thicknessCasing })
                    }}
                    floatValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <Select
                    value={civilEng.natureCasing}
                    label={i18n.natureCasing}
                    keyvalue='code'
                    options={getSandreList(sandreCodes, SANDRE.TUBAGES_MATERIAU)}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ natureCasing: v })
                        onChangeVisit(getVisitSandreSelectChange(sandreCodes, SANDRE.TUBAGES_MATERIAU, i18n.natureCasing, civilEng.natureCasing, v))
                    }}
                    integerValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <NumberField
                    value={civilEng.depthCasing}
                    title={i18n.depthCasing}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ depthCasing: v })
                        onChangeVisit({ previousValue: civilEng.depthCasing, newValue: v, field: i18n.depthCasing })
                    }}
                    floatValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <Checkbox
                    checked={civilEng.crepineWork}
                    label={i18n.crepineWork}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ crepineWork: v })
                        onChangeVisit(getVisitCheckBoxChange(i18n.crepineWork, civilEng.crepineWork, v))
                    }}
                    disabled={readMode}
                />
            </Grid>
            <Grid size={6}>
                <NumberField
                    value={civilEng.depthPump}
                    title={i18n.depthPump}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ depthPump: v })
                        onChangeVisit({ previousValue: civilEng.depthPump, newValue: v, field: i18n.depthPump })
                    }}
                    floatValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <NumberField
                    value={civilEng.depthProbe}
                    title={i18n.depthProbe}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ depthProbe: v })
                        onChangeVisit({ previousValue: civilEng.depthProbe, newValue: v, field: i18n.depthProbe })
                    }}
                    floatValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <NumberField
                    value={civilEng.TNLevel}
                    title={template(i18n.TNLevel)({ nG: getGeneralLevelling() })}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ TNLevel: v })
                        onChangeVisit({ previousValue: civilEng.TNLevel, newValue: v, field: template(i18n.TNLevel)({ nG: getGeneralLevelling() }) })
                    }}
                    floatValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <NumberField
                    value={civilEng.flangeLevel}
                    title={template(i18n.flangeLevel)({ nG: getGeneralLevelling() })}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ flangeLevel: v })
                        onChangeVisit({ previousValue: civilEng.flangeLevel, newValue: v, field: template(i18n.flangeLevel)({ nG: getGeneralLevelling() }) })
                    }}
                    floatValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <NumberField
                    value={civilEng.landmarkLevel}
                    title={template(i18n.landmarkLevel)({ nG: getGeneralLevelling() })}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ landmarkLevel: v })
                        onChangeVisit({ previousValue: civilEng.landmarkLevel, newValue: v, field: template(i18n.landmarkLevel)({ nG: getGeneralLevelling() }) })
                    }}
                    floatValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <Checkbox
                    checked={civilEng.coping}
                    label={i18n.coping}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ coping: v })
                        onChangeVisit(getVisitCheckBoxChange(i18n.coping, civilEng.coping, v))
                    }}
                    disabled={readMode}
                />
            </Grid>
            <Grid size={6}>
                <Select
                    value={civilEng.rollover}
                    label={i18n.rollover}
                    keyvalue='code'
                    options={getSandreList(sandreCodes, SANDRE.INSTALLATIONS_CAPOTAGE)}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ rollover: v })
                        onChangeVisit(getVisitSandreSelectChange(sandreCodes, SANDRE.INSTALLATIONS_CAPOTAGE, i18n.rollover, civilEng.rollover, v))
                    }}
                    integerValue
                    readMode={readMode}
                />
            </Grid>
            <Grid size={6}>
                <Checkbox
                    checked={civilEng.waterproofHead}
                    label={i18n.waterproofHead}
                    onChange={(v) => {
                        onChangeCaptureCivilEng({ waterproofHead: v })
                        onChangeVisit(getVisitCheckBoxChange(i18n.waterproofHead, civilEng.waterproofHead, v))
                    }}
                    disabled={readMode}
                />
            </Grid>
            <Grid size={6}>
                <Input
                    value={getDate(civilEng.lastInspection)}
                    title={i18n.lastInspection}
                    onChange={v => {
                        onChangeDate(v, v2 => onChangeCaptureCivilEng({ lastInspection: v2 }))
                        onChangeVisit(getVisitDatePickerChange(i18n.lastInspection, civilEng.lastInspection, v))
                    }}
                    readMode={readMode}
                />
            </Grid>
        </>
    )
}

CaptureCivilEngPanel.propTypes = {
    capture: PropTypes.instanceOf(DtoCaptureStation),
    readMode: PropTypes.bool,
    onChange: PropTypes.func,
    onChangeVisit: PropTypes.func,
}

export default CaptureCivilEngPanel
